import React from 'react'
import './../css/index.scss'

type MyReactTableProps = {
    tableInstance: { getTableProps: any, getTableBodyProps: any, headerGroups: any, rows: any, prepareRow: any, visibleColumns: any},
    renderExpandedRow?: any
}

const MyReactTable = (props: MyReactTableProps) => {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, visibleColumns } = props.tableInstance

    return (
        <table {...getTableProps()}>
            <thead>
            {headerGroups.map((headerGroup: any) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column: any) => (
                        <th {...column.getHeaderProps()}>
                            {column.render('Header')}
                        </th>
                    ))}
                </tr>
            ))}
            </thead>
            <tbody {...getTableBodyProps()}>
            {rows.map((row: any) => {
                prepareRow(row);

                return (
                    <React.Fragment >
                        <tr {...row.getRowProps()}>
                            {row.cells.map((cell: any) => {
                                return (
                                    <td {...cell.getCellProps()}>
                                        {cell.render('Cell')}
                                    </td>
                                );
                            })}
                        </tr>
                        {row.isExpanded ? (
                            <tr {...row.getRowProps()} key={row.original.id + '-expanded-tr'}>
                                <td colSpan={visibleColumns.length} role="cell" key={row.original.id + '-expanded-td'}>
                                    {props.renderExpandedRow({ row })}
                                </td>
                            </tr>
                        ) : null}
                    </React.Fragment>
                );
            })}
            </tbody>
        </table>

    )
}

export type FilterType = {
    column: {
        filterValue: any
        setFilter: any
    }
}

export const NullFilter = (input: FilterType) => {
    return (
        <div></div>
    )
}

export default MyReactTable;
